import React from 'react';
import { Modal, Form, Button, ButtonGroup } from 'react-bootstrap';

function CreateTicketModal({
                               show,
                               onHide,
                               formData,
                               setFormData,
                               handleCreateTicket,
                               getTicketTypeLabel
                           }) {
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData(prev => ({ ...prev, file }));
    };

    const handleTicketTypeChange = (type) => {
        setFormData(prev => ({ ...prev, ticketType: type }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Créer une nouvelle demande</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleCreateTicket}>
                    <Form.Group controlId="ticketType">
                        <Form.Label>Type de demande</Form.Label>
                        <div>
                            <ButtonGroup style={{ marginLeft: '5px' }}>
                                <Button
                                    variant="primary"
                                    active={formData.ticketType === 'HELP'}
                                    onClick={() => handleTicketTypeChange('HELP')}
                                >
                                    {getTicketTypeLabel('HELP')}
                                </Button>
                                <Button
                                    variant="primary"
                                    active={formData.ticketType === 'ANOMALY'}
                                    onClick={() => handleTicketTypeChange('ANOMALY')}
                                >
                                    {getTicketTypeLabel('ANOMALY')}
                                </Button>
                            </ButtonGroup>
                        </div>
                    </Form.Group>
                    <Form.Group controlId="subject">
                        <Form.Label>Sujet</Form.Label>
                        <Form.Control type="text" name="subject" onChange={handleChange} />
                    </Form.Group>
                    <Form.Group controlId="description">
                        <Form.Label>
                            {formData.ticketType === 'ANOMALY' ? 'Comportement observé / Comportement attendu' : 'Descriptif'}
                        </Form.Label>
                        <Form.Control as="textarea" rows={3} name="description" onChange={handleChange} />
                    </Form.Group>
                    <Form.Group controlId="file">
                        <Form.Label>{formData.ticketType === 'ANOMALY' ? "Capture d'écran au format PNG" : 'Pièce jointe (facultatif, au format PNG, JPG ou PDF, 5Mo maximum)'}</Form.Label>
                        <Form.Control type="file" name="file" onChange={handleFileChange} accept=".png, .pdf, .jpg" />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="secondary" onClick={onHide}>Annuler</Button>
                <Button variant="primary" onClick={handleCreateTicket}>Confirmer</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CreateTicketModal;